export default __webpack_public_path__ + "static/media/ethics.74e4cb75.svg";